"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RecordingIcon = void 0;
var _core = require("@material-ui/core");
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var RecordingIcon = function RecordingIcon(props) {
  return /*#__PURE__*/_react.default.createElement(_core.SvgIcon, _extends({}, props, {
    viewBox: "0 0 24 24"
  }), /*#__PURE__*/_react.default.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#clip0_5549_299530)"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    width: "24",
    height: "24",
    rx: "12",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    width: "24",
    height: "24",
    rx: "12",
    fill: "#13131C"
  }), /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#clip1_5549_299530)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M15.7617 10.875L18.75 7.88672V16.1133L15.7617 13.125V15.7617C15.7617 15.9727 15.6797 16.1484 15.5156 16.2891C15.375 16.4297 15.1992 16.5 14.9883 16.5H5.98828C5.77734 16.5 5.60156 16.4297 5.46094 16.2891C5.32031 16.1484 5.25 15.9727 5.25 15.7617V8.23828C5.25 8.02735 5.32031 7.85156 5.46094 7.71094C5.60156 7.57031 5.77734 7.5 5.98828 7.5H14.9883C15.1992 7.5 15.375 7.57031 15.5156 7.71094C15.6797 7.85156 15.7617 8.02735 15.7617 8.23828V10.875Z",
    fill: "white"
  }))), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "clip0_5549_299530"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    width: "24",
    height: "24",
    rx: "12",
    fill: "white"
  })), /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "clip1_5549_299530"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    width: "18",
    height: "18",
    fill: "white",
    transform: "translate(3 3)"
  })))));
};
exports.RecordingIcon = RecordingIcon;